import {OutsourcedStatics} from "../../config/OutsourcedStatics";
import {gsap} from "gsap";
import {OutsourcedGameAssets} from "../../OutsourcedGameAssets";
import {Outsourced} from "../../Outsourced";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {OutsourcedSymbol, SymbolArgs} from "./OutsourcedSymbol";

export class MaxWinSymbol extends OutsourcedSymbol {

    constructor(args:SymbolArgs) {
        super(args);

        this.removeChild(this.mainSprite);
        this.removeChild(this.spinSprite);

        this.mainSprite = new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(this.symbolName, `_${this.reelID + 1}`))[0]);
        this.mainSprite.anchor.set(0.5,0.5);
        this.addChildAt(this.mainSprite, 0);

        this.spinSprite = new PIXI.Sprite(Outsourced.assetLoader.getTextures(OutsourcedGameAssets.getSymbolStateTexturePath(this.symbolName, `_${this.reelID + 1}_spin`))[0]);
        this.spinSprite.anchor.set(0.5,0.5);
        this.spinSprite.alpha = 0;
        this.addChildAt(this.spinSprite, 0);
    }
}